import Grid from '@mui/material/Grid';
import MouthBreathText from './MouthBreathText';
import MicroButtonGroup from '../Breath/BreathAux/MicroButtonGroup';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import GetBreath from './Profiling/GetBreath';



export default function MouthSectionBreath() {

    
    return (

     <SectionStructure
        
        sectiontext=    { <MouthBreathText /> }
        sectiondiagroup=    { <MicroButtonGroup />} 

        sectioncards=  {
        
            <Grid container spacing={0}>
                    <Grid size={{xs:12, xl:12}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start'}}>  <GetBreath /> </Grid>
                     <Grid size={{xs:12, xl:6}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start'}}>   </Grid>
                </Grid>        
        }

    />

    )
}